export default __webpack_public_path__ + "static/media/customer.630f8986.png";